interface TitleValueProps {
  title: string;
  value: string;
}

const TitleValue = ({ title, value }: TitleValueProps) => {
  return (
    <div>
      <div className="font-bold">{title}</div>
      <div className="text-sm">{value}</div>
    </div>
  );
};

export default TitleValue;
